import React from 'react';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/RatingModal.css';
import RespModal from './RespModal';
import cross from '../../Assets/ContainerStatus/Assets_Desktop/close-icon.svg';

function RatingModal(props) {
    return (
        <RespModal hasOpen={props.hasOpen}>
            <div className="ratingmodalsizeaddprofile" >
                <div className='modalcrossRatingModal'>
                    <img src={cross} onClick={props.onCrossModal} width="30" height="30" class="d-inline-block align-top" alt="" loading="lazy" />
                </div>
                {/* <Image src={success} /><br /><br /> */}
                <div id="modalcontainsuccessaddprofilerating">
                    {props.children}
                </div>
                <div class="cancelresploginbuttonouterrating">
                    <Button
                        id="cancelresploginbuttoaddprofilerating"
                        type="button"
                        class="btn btn-dark"
                        onClick={props.onCloseModal}
                    >Submit
                 </Button>
                </div>
            </div>
        </RespModal>
    );
}
export default RatingModal;
